import mSdk from '@dt/web-monitor'
import ENV from '@env'
import { appMobx } from '@mobxStore'
import { getPlatform, localStore } from '@utils'
import { ddayjs, uuid } from '@dt/fe-utils'

// 事件名称：appstart、pagein、pageout、ad_show、ad_click、ad_order、userlogin
type TEventType = 'appstart' | 'pagein' | 'pageout' | 'ad_show' | 'ad_click' | 'ad_order' | 'userlogin'
// 广告位置
type TAdvertCaseType = 'home' | 'menu' | 'openScreen' | 'finish' | 'buyTogether' | 'popUps' | 'shopwindow' | 'waterfall';

class WebMonitor {
  /** logger */
  static sdk: any = null

  // 标记一下已经采集，采集之后不需要
  static trackMap = {
    ad_click: {},
    ad_show: {},
  }
  /**
   * 初始化
   */
  static init (userId: number) {
    try {
      const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
      const cliType = isWeixinMiniProgram ? 'wxminiapp' : isAliPayMiniProgram ? 'aliminiapp' : 'h5'
      const _userId = userId || localStore.get(`ls.visitor.${Config.BRANDID}`)?.id
      this.sdk = mSdk.init({
        cliType,
        url: `${ENV.ONENET}/upload/event/v0.1`,
        devId: Config.gopenId || appMobx.deviceId,
        brandId: Config.BRANDID,
        storeId: Config.STOREID,
        sessionId: sessionStorage.getItem('_bl_sid') || uuid(),
        userId: _userId,
      })
    } catch (error) {
    }
  }
  /**
   * 上报采集数据
   */
  static trackClicks ({ eventType, ad, adType, page }: { eventType: TEventType; ad: TAdvert; adType: TAdvertCaseType; page: number }) {
    if (bo !== 'cn') return
    try {
      if (ad.pic && this.trackMap[eventType]?.[ad.pic]) {
        return
      }
      const pageName = window.location.pathname
      this.trackMap[eventType][ad.pic] = true
      const adContent = ad.pic
      if (!adContent) return
      this.sdk?.trackClicks({
        event: eventType,
        event_time: ddayjs().format('YYYY-MM-DD HH:mm:ss'), // 事件发生时间
        page_name: pageName, // 页面名
        content: {
          ad_type: adType,
          ad_page: page,
          ad_content: adContent,
          target_type: ad.type
        }
      })
    } catch (error) {
    }
  }

  /**
   * 上报下单
   */
  static trackOrder (datas: any | any[], orderId: string) {
    try {
      this.sdk?.trackClicks(datas, true, { orderId })
    } catch (error) {
    }
  }
  /**
   * 修改配置项
   */
  static setConfig (config: { [key: string]: any }) {
    if (!this.sdk) return
    try {
      this.sdk?.setConfig(config)
    } catch (error) {
    }
  }
}

export default WebMonitor
